export const CUENTA_GRABAR = "CUENTA_GRABAR";
export const CUENTA_GRABAR_SUCCESS = "CUENTA_GRABAR_SUCCESS";
export const CUENTA_GRABAR_ERROR = "CUENTA_GRABAR_ERROR";

export const grabarCuenta = (cuenta, onSuccess) => ({
  type: CUENTA_GRABAR,
  cuenta,
  onSuccess,
});

export const grabarCuentaSuccess = (respuestaServidor) => ({
  type: CUENTA_GRABAR_SUCCESS,
  respuestaServidor,
});

export const grabarCuentaError = (errorContenido) => ({
  type: CUENTA_GRABAR_ERROR,
  errorContenido,
});

export const CUENTA_LISTAR = "CUENTA_LISTAR";
export const CUENTA_LISTAR_SUCCESS = "CUENTA_LISTAR_SUCCESS";
export const CUENTA_LISTAR_ERROR = "CUENTA_LISTAR_ERROR";

export const listarCuenta = (paginacion, onSuccess) => ({
  type: CUENTA_LISTAR,
  paginacion,
  onSuccess,
});

export const listarCuentaSuccess = (respuestaServidor) => ({
  type: CUENTA_LISTAR_SUCCESS,
  respuestaServidor,
});

export const listarCuentaError = (errorContenido) => ({
  type: CUENTA_LISTAR_ERROR,
  errorContenido,
});

export const CUENTA_USUARIO_LISTAR = "CUENTA_USUARIO_LISTAR";
export const CUENTA_USUARIO_LISTAR_SUCCESS = "CUENTA_USUARIO_LISTAR_SUCCESS";
export const CUENTA_USUARIO_LISTAR_ERROR = "CUENTA_USUARIO_LISTAR_ERROR";

export const listarCuentaUsuario = (onSuccess) => ({
  type: CUENTA_USUARIO_LISTAR,
  onSuccess,
});

export const listarCuentaUsuarioSuccess = (respuestaServidor) => ({
  type: CUENTA_USUARIO_LISTAR_SUCCESS,
  respuestaServidor,
});

export const listarCuentaUsuarioError = (errorContenido) => ({
  type: CUENTA_USUARIO_LISTAR_ERROR,
  errorContenido,
});

export const CUENTA_PARA_EDITAR = "CUENTA_PARA_EDITAR";
export const editarCuenta = (cuenta,onSuccess) => ({
  type: CUENTA_PARA_EDITAR,
  cuenta,
  onSuccess
});

export const CUENTAS_DESDE_ACCESO = "CUENTAS_DESDE_ACCESO";
export const guardarCuentasDesdeAcceso = (cuentasDesdeAcceso) => ({
  type: CUENTAS_DESDE_ACCESO,
  cuentasDesdeAcceso
});

export const LISTAR_MAX_PLACA_EXENTA = "LISTAR_MAX_PLACA_EXENTA";
export const LISTAR_MAX_PLACA_EXENTA_SUCCESS = "LISTAR_MAX_PLACA_EXENTA_SUCCESS";
export const LISTAR_MAX_PLACA_EXENTA_ERROR = "LISTAR_MAX_PLACA_EXENTA_ERROR";

export const listarMaxPlacaExenta = (cuenta, onSuccess) => ({
  type: LISTAR_MAX_PLACA_EXENTA,
  cuenta,
  onSuccess,
});

export const listarMaxPlacaExentaSuccess = (respuestaServidor) => ({
  type: LISTAR_MAX_PLACA_EXENTA_SUCCESS,
  respuestaServidor,
});

export const listarMaxPlacaExentaError = (errorContenido) => ({
  type: LISTAR_MAX_PLACA_EXENTA_ERROR,
  errorContenido,
});

export const LISTAR_MAX_ZONAS = "LISTAR_MAX_ZONAS";
export const LISTAR_MAX_ZONAS_SUCCESS = "LISTAR_MAX_ZONAS_SUCCESS";
export const LISTAR_MAX_ZONAS_ERROR = "LISTAR_MAX_ZONAS_ERROR";

export const listarMaxZonas = (cuenta, onSuccess) => ({
  type: LISTAR_MAX_ZONAS,
  cuenta,
  onSuccess,
});

export const listarMaxZonasSuccess = (respuestaServidor) => ({
  type: LISTAR_MAX_ZONAS_SUCCESS,
  respuestaServidor,
});

export const listarMaxZonasError = (errorContenido) => ({
  type: LISTAR_MAX_ZONAS_ERROR,
  errorContenido,
});

export const LISTAR_MAX_PERFILES_ADMINISTRADOR = "LISTAR_MAX_PERFILES_ADMINISTRADOR";
export const LISTAR_MAX_PERFILES_ADMINISTRADOR_SUCCESS = "LISTAR_MAX_PERFILES_ADMINISTRADOR_SUCCESS";
export const LISTAR_MAX_PERFILES_ADMINISTRADOR_ERROR = "LISTAR_MAX_PERFILES_ADMINISTRADOR_ERROR";

export const listarMaxPerfilesAdministrador = (cuenta, onSuccess) => ({
  type: LISTAR_MAX_PERFILES_ADMINISTRADOR,
  cuenta,
  onSuccess,
});

export const listarMaxPerfilesAdministradorSuccess = (respuestaServidor) => ({
  type: LISTAR_MAX_PERFILES_ADMINISTRADOR_SUCCESS,
  respuestaServidor,
});

export const listarMaxPerfilesAdministradorError = (errorContenido) => ({
  type: LISTAR_MAX_PERFILES_ADMINISTRADOR_ERROR,
  errorContenido,
});

export const LISTAR_MAX_PERFILES_SUPERVISOR = "LISTAR_MAX_PERFILES_SUPERVISOR";
export const LISTAR_MAX_PERFILES_SUPERVISOR_SUCCESS = "LISTAR_MAX_PERFILES_SUPERVISOR_SUCCESS";
export const LISTAR_MAX_PERFILES_SUPERVISOR_ERROR = "LISTAR_MAX_PERFILES_SUPERVISOR_ERROR";

export const listarMaxPerfilesSupervisor = (cuenta, onSuccess) => ({
  type: LISTAR_MAX_PERFILES_SUPERVISOR,
  cuenta,
  onSuccess,
});

export const listarMaxPerfilesSupervisorSuccess = (respuestaServidor) => ({
  type: LISTAR_MAX_PERFILES_SUPERVISOR_SUCCESS,
  respuestaServidor,
});

export const listarMaxPerfilesSupervisorError = (errorContenido) => ({
  type: LISTAR_MAX_PERFILES_SUPERVISOR_ERROR,
  errorContenido,
});

export const LISTAR_MAX_PERFILES_AUXILIAR = "LISTAR_MAX_PERFILES_AUXILIAR";
export const LISTAR_MAX_PERFILES_AUXILIAR_SUCCESS = "LISTAR_MAX_PERFILES_AUXILIAR_SUCCESS";
export const LISTAR_MAX_PERFILES_AUXILIAR_ERROR = "LISTAR_MAX_PERFILES_AUXILIAR_ERROR";

export const listarMaxPerfilesAuxiliar = (cuenta, onSuccess) => ({
  type: LISTAR_MAX_PERFILES_AUXILIAR,
  cuenta,
  onSuccess,
});

export const listarMaxPerfilesAuxiliarSuccess = (respuestaServidor) => ({
  type: LISTAR_MAX_PERFILES_AUXILIAR_SUCCESS,
  respuestaServidor,
});

export const listarMaxPerfilesAuxiliarError = (errorContenido) => ({
  type: LISTAR_MAX_PERFILES_AUXILIAR_ERROR,
  errorContenido,
});

export const LISTAR_MAX_PERFILES_PROMOTOR = "LISTAR_MAX_PERFILES_PROMOTOR";
export const LISTAR_MAX_PERFILES_PROMOTOR_SUCCESS = "LISTAR_MAX_PERFILES_PROMOTOR_SUCCESS";
export const LISTAR_MAX_PERFILES_PROMOTOR_ERROR = "LISTAR_MAX_PERFILES_PROMOTOR_ERROR";

export const listarMaxPerfilesPromotor = (cuenta, onSuccess) => ({
  type: LISTAR_MAX_PERFILES_PROMOTOR,
  cuenta,
  onSuccess,
});

export const listarMaxPerfilesPromotorSuccess = (respuestaServidor) => ({
  type: LISTAR_MAX_PERFILES_PROMOTOR_SUCCESS,
  respuestaServidor,
});

export const listarMaxPerfilesPromotorError = (errorContenido) => ({
  type: LISTAR_MAX_PERFILES_PROMOTOR_ERROR,
  errorContenido,
});

export const LISTAR_MAX_PERFILES_MUNICIPIO = "LISTAR_MAX_PERFILES_MUNICIPIO";
export const LISTAR_MAX_PERFILES_MUNICIPIO_SUCCESS = "LISTAR_MAX_PERFILES_MUNICIPIO_SUCCESS";
export const LISTAR_MAX_PERFILES_MUNICIPIO_ERROR = "LISTAR_MAX_PERFILES_MUNICIPIO_ERROR";

export const listarMaxPerfilesMunicipio = (cuenta, onSuccess) => ({
  type: LISTAR_MAX_PERFILES_MUNICIPIO,
  cuenta,
  onSuccess,
});

export const listarMaxPerfilesMunicipioSuccess = (respuestaServidor) => ({
  type: LISTAR_MAX_PERFILES_MUNICIPIO_SUCCESS,
  respuestaServidor,
});

export const listarMaxPerfilesMunicipioError = (errorContenido) => ({
  type: LISTAR_MAX_PERFILES_MUNICIPIO_ERROR,
  errorContenido,
});

export const LISTAR_MAX_PERFILES_VISOR = "LISTAR_MAX_PERFILES_VISOR";
export const LISTAR_MAX_PERFILES_VISOR_SUCCESS = "LISTAR_MAX_PERFILES_VISOR_SUCCESS";
export const LISTAR_MAX_PERFILES_VISOR_ERROR = "LISTAR_MAX_PERFILES_VISOR_ERROR";

export const listarMaxPerfilesVisor = (cuenta, onSuccess) => ({
  type: LISTAR_MAX_PERFILES_VISOR,
  cuenta,
  onSuccess,
});

export const listarMaxPerfilesVisorSuccess = (respuestaServidor) => ({
  type: LISTAR_MAX_PERFILES_VISOR_SUCCESS,
  respuestaServidor,
});

export const listarMaxPerfilesVisorError = (errorContenido) => ({
  type: LISTAR_MAX_PERFILES_VISOR_ERROR,
  errorContenido,
});

export const CUENTA_LISTAR_ENRIQUECIDA = "CUENTA_LISTAR_ENRIQUECIDA";

export const listarCuentaEnriquecidaSuccess = (respuestaServidor) => ({
  type: CUENTA_LISTAR_ENRIQUECIDA,
  respuestaServidor,
});


export const GRABAR_LIMITE_PLACA_EXENTA = "GRABAR_LIMITE_PLACA_EXENTA";
export const GRABAR_LIMITE_PLACA_EXENTA_SUCCESS = "GRABAR_LIMITE_PLACA_EXENTA_SUCCESS";
export const GRABAR_LIMITE_PLACA_EXENTA_ERROR = "GRABAR_LIMITE_PLACA_EXENTA_ERROR";

export const grabarLimitePlacaExenta = (cuenta, valor, onSuccess) => ({
  type: GRABAR_LIMITE_PLACA_EXENTA,
  cuenta,
  valor,
  onSuccess,
});

export const grabarLimitePlacaExentaSuccess = (respuestaServidor) => ({
  type: GRABAR_LIMITE_PLACA_EXENTA_SUCCESS,
  respuestaServidor,
});

export const grabarLimitePlacaExentaError = (errorContenido) => ({
  type: GRABAR_LIMITE_PLACA_EXENTA_ERROR,
  errorContenido,
});

export const GRABAR_LIMITE_MAX_ZONAS = "GRABAR_LIMITE_MAX_ZONAS";
export const GRABAR_LIMITE_MAX_ZONAS_SUCCESS = "GRABAR_LIMITE_MAX_ZONAS_SUCCESS";
export const GRABAR_LIMITE_MAX_ZONAS_ERROR = "GRABAR_LIMITE_MAX_ZONAS_ERROR";

export const grabarLimiteMaxZonas = (cuenta, valor, onSuccess) => ({
  type: GRABAR_LIMITE_MAX_ZONAS,
  cuenta,
  valor,
  onSuccess,
});

export const grabarLimiteMaxZonasSuccess = (respuestaServidor) => ({
  type: GRABAR_LIMITE_MAX_ZONAS_SUCCESS,
  respuestaServidor,
});

export const grabarLimiteMaxZonasError = (errorContenido) => ({
  type: GRABAR_LIMITE_MAX_ZONAS_ERROR,
  errorContenido,
});


export const GRABAR_LIMITE_MAX_PERFILES_ADMINISTRADOR = "GRABAR_LIMITE_MAX_PERFILES_ADMINISTRADOR";
export const GRABAR_LIMITE_MAX_PERFILES_ADMINISTRADOR_SUCCESS = "GRABAR_LIMITE_MAX_PERFILES_ADMINISTRADOR_SUCCESS";
export const GRABAR_LIMITE_MAX_PERFILES_ADMINISTRADOR_ERROR = "GRABAR_LIMITE_MAX_PERFILES_ADMINISTRADOR_ERROR";

export const grabarLimiteMaxPerfilesAdministrador = (cuenta, valor, onSuccess) => ({
  type: GRABAR_LIMITE_MAX_PERFILES_ADMINISTRADOR,
  cuenta,
  valor,
  onSuccess,
});

export const grabarLimiteMaxPerfilesAdministradorSuccess = (respuestaServidor) => ({
  type: GRABAR_LIMITE_MAX_PERFILES_ADMINISTRADOR_SUCCESS,
  respuestaServidor,
});

export const grabarLimiteMaxPerfilesAdministradorError = (errorContenido) => ({
  type: GRABAR_LIMITE_MAX_PERFILES_ADMINISTRADOR_ERROR,
  errorContenido,
});

export const GRABAR_LIMITE_MAX_PERFILES_SUPERVISOR = "GRABAR_LIMITE_MAX_PERFILES_SUPERVISOR";
export const GRABAR_LIMITE_MAX_PERFILES_SUPERVISOR_SUCCESS = "GRABAR_LIMITE_MAX_PERFILES_SUPERVISOR_SUCCESS";
export const GRABAR_LIMITE_MAX_PERFILES_SUPERVISOR_ERROR = "GRABAR_LIMITE_MAX_PERFILES_SUPERVISOR_ERROR";

export const grabarLimiteMaxPerfilesSupervisor = (cuenta, valor, onSuccess) => ({
  type: GRABAR_LIMITE_MAX_PERFILES_SUPERVISOR,
  cuenta,
  valor,
  onSuccess,
});

export const grabarLimiteMaxPerfilesSupervisorSuccess = (respuestaServidor) => ({
  type: GRABAR_LIMITE_MAX_PERFILES_SUPERVISOR_SUCCESS,
  respuestaServidor,
});

export const grabarLimiteMaxPerfilesSupervisorError = (errorContenido) => ({
  type: GRABAR_LIMITE_MAX_PERFILES_SUPERVISOR_ERROR,
  errorContenido,
});

export const GRABAR_LIMITE_MAX_PERFILES_AUXILIAR = "GRABAR_LIMITE_MAX_PERFILES_AUXILIAR";
export const GRABAR_LIMITE_MAX_PERFILES_AUXILIAR_SUCCESS = "GRABAR_LIMITE_MAX_PERFILES_AUXILIAR_SUCCESS";
export const GRABAR_LIMITE_MAX_PERFILES_AUXILIAR_ERROR = "GRABAR_LIMITE_MAX_PERFILES_AUXILIAR_ERROR";

export const grabarLimiteMaxPerfilesAuxiliar = (cuenta, valor, onSuccess) => ({
  type: GRABAR_LIMITE_MAX_PERFILES_AUXILIAR,
  cuenta,
  valor,
  onSuccess,
});

export const grabarLimiteMaxPerfilesAuxiliarSuccess = (respuestaServidor) => ({
  type: GRABAR_LIMITE_MAX_PERFILES_AUXILIAR_SUCCESS,
  respuestaServidor,
});

export const grabarLimiteMaxPerfilesAuxiliarError = (errorContenido) => ({
  type: GRABAR_LIMITE_MAX_PERFILES_AUXILIAR_ERROR,
  errorContenido,
});


export const GRABAR_LIMITE_MAX_PERFILES_MUNICIPIO = "GRABAR_LIMITE_MAX_PERFILES_MUNICIPIO";
export const GRABAR_LIMITE_MAX_PERFILES_MUNICIPIO_SUCCESS = "GRABAR_LIMITE_MAX_PERFILES_MUNICIPIO_SUCCESS";
export const GRABAR_LIMITE_MAX_PERFILES_MUNICIPIO_ERROR = "GRABAR_LIMITE_MAX_PERFILES_MUNICIPIO_ERROR";

export const grabarLimiteMaxPerfilesMunicipio = (cuenta, valor, onSuccess) => ({
  type: GRABAR_LIMITE_MAX_PERFILES_MUNICIPIO,
  cuenta,
  valor,
  onSuccess,
});

export const grabarLimiteMaxPerfilesMunicipioSuccess = (respuestaServidor) => ({
  type: GRABAR_LIMITE_MAX_PERFILES_MUNICIPIO_SUCCESS,
  respuestaServidor,
});

export const grabarLimiteMaxPerfilesMunicipioError = (errorContenido) => ({
  type: GRABAR_LIMITE_MAX_PERFILES_MUNICIPIO_ERROR,
  errorContenido,
});


export const GRABAR_LIMITE_MAX_PERFILES_VISOR = "GRABAR_LIMITE_MAX_PERFILES_VISOR";
export const GRABAR_LIMITE_MAX_PERFILES_VISOR_SUCCESS = "GRABAR_LIMITE_MAX_PERFILES_VISOR_SUCCESS";
export const GRABAR_LIMITE_MAX_PERFILES_VISOR_ERROR = "GRABAR_LIMITE_MAX_PERFILES_VISOR_ERROR";

export const grabarLimiteMaxPerfilesVisor = (cuenta, valor, onSuccess) => ({
  type: GRABAR_LIMITE_MAX_PERFILES_VISOR,
  cuenta,
  valor,
  onSuccess,
});

export const grabarLimiteMaxPerfilesVisorSuccess = (respuestaServidor) => ({
  type: GRABAR_LIMITE_MAX_PERFILES_VISOR_SUCCESS,
  respuestaServidor,
});

export const grabarLimiteMaxPerfilesVisorError = (errorContenido) => ({
  type: GRABAR_LIMITE_MAX_PERFILES_VISOR_ERROR,
  errorContenido,
});


export const GRABAR_LIMITE_MAX_PERFILES_PROMOTOR = "GRABAR_LIMITE_MAX_PERFILES_PROMOTOR";
export const GRABAR_LIMITE_MAX_PERFILES_PROMOTOR_SUCCESS = "GRABAR_LIMITE_MAX_PERFILES_PROMOTOR_SUCCESS";
export const GRABAR_LIMITE_MAX_PERFILES_PROMOTOR_ERROR = "GRABAR_LIMITE_MAX_PERFILES_PROMOTOR_ERROR";

export const grabarLimiteMaxPerfilesPromotor = (cuenta, valor, onSuccess) => ({
  type: GRABAR_LIMITE_MAX_PERFILES_PROMOTOR,
  cuenta,
  valor,
  onSuccess,
});

export const grabarLimiteMaxPerfilesPromotorSuccess = (respuestaServidor) => ({
  type: GRABAR_LIMITE_MAX_PERFILES_PROMOTOR_SUCCESS,
  respuestaServidor,
});

export const grabarLimiteMaxPerfilesPromotorError = (errorContenido) => ({
  type: GRABAR_LIMITE_MAX_PERFILES_PROMOTOR_ERROR,
  errorContenido,
});